import { User } from '../../user/objects/user';
import { Permission } from '../objects/permission';

export const TOGGLE_ALL_PERMISSIONS = 'PERMISSIONS_TOGGLE_ALL_PERMISSIONS';
export const UPDATE_PERMISSIONS = 'PERMISSIONS_UPDATE_PERMISSIONS';

interface ToggleAllPermissionsAction {
    type: typeof TOGGLE_ALL_PERMISSIONS,
    payload: {
        profile: null | User,
        permissions: null | Permission[],
        value: boolean
    }
}

interface UpdatePermissionsAction {
    type: typeof UPDATE_PERMISSIONS,
    payload: {
        codename: string,
        value: boolean
    }
}

export type PermissionsActionTypes = ToggleAllPermissionsAction | UpdatePermissionsAction;